import { Route, Switch } from 'react-router-dom'
import React from 'react'
import Fill from '../fill/fill'
import GoodsList from '../goods-list/goods-list'
import Pay from '../pay/pay'
import couponList from '../fill/coupon-list/coupon-list'

class OrderRoute extends React.Component<any, any> {
  render() {
    return (
      <Switch>
        <Route
          path={`${this.props.match.path}/prepare/:type/:depot_id`}
          component={Fill}
        />
        <Route path={`${this.props.match.path}/list`} component={GoodsList} />
        <Route
          path={`${this.props.match.path}/pay/:order_sn/:path`}
          component={Pay}
        />
        <Route
          path={`${this.props.match.path}/coupon-list/:type/:depot_id`}
          component={couponList}
        />
      </Switch>
    )
  }
}

export default OrderRoute
